@let checklist = items;
@if (checklist.length > 0) {
    <mat-card appearance="raised" class="checklist" data-testid="getting-started-checklist">
        <div class="heading">
            <div>
                <h3>Getting started</h3>
                <span class="progress-text">{{doneCount(checklist)}} of {{checklist.length}} done</span>
            </div>
            <button mat-button (click)="hide()" matTooltip="You can still find the walkthrough, tutorials and videos in the help menu">Hide checklist</button>
        </div>
        <mat-progress-bar mode="determinate" [value]="100 * doneCount(checklist) / checklist.length" aria-label="Getting started progress"></mat-progress-bar>

        <ol class="items">
            @for (i of checklist; track i.item) {
                <li [class.done]="i.done" [class.next]="isNext(checklist, i)">
                    <mat-icon class="status" [attr.aria-label]="i.done ? 'Done' : 'To do'">{{i.done ? 'check_circle' : 'radio_button_unchecked'}}</mat-icon>
                    <div class="text">
                        <div class="title">{{TEXT[i.item].title}}</div>
                        @if (!i.done) {
                            <div class="description">{{TEXT[i.item].description}}</div>
                        }
                    </div>
                    @if (!i.done) {
                        @if (isNext(checklist, i)) {
                            <button mat-flat-button color="accent" (click)="act(i.item)">{{TEXT[i.item].action}}</button>
                        }@else {
                            <button mat-stroked-button (click)="act(i.item)">{{TEXT[i.item].action}}</button>
                        }
                    }
                </li>
            }
        </ol>

        <div class="learn">
            <span>Want to learn more?</span>
            <button mat-button (click)="learn(ONBOARDING_CHOICE.WALKTHROUGH)">Learn the basics of modelling</button>
            <button mat-button (click)="learn(ONBOARDING_CHOICE.TUTORIAL)">Tutorials</button>
            <button mat-button (click)="learn(ONBOARDING_CHOICE.VIDEOS)">Videos</button>
        </div>
    </mat-card>
}
